<ll-toolnavbar>
    <banner-toolnavbar [displayButtons]=""></banner-toolnavbar>
</ll-toolnavbar>
<ll-titulo>{{ loggedLayoutTitle | easyplaceholder: "Formulario banners" }}</ll-titulo>

<banners-new listRoute="banners"></banners-new>
